import { ReactNode } from 'react';
import styles from './SidebarGroup.module.css';

/**
 * Props del componente SidebarGroup
 * @param title - Título del grupo de menú
 * @param children - Items del menú que pertenecen a este grupo
 * @param isCollapsed - Si el sidebar está colapsado (modo mini)
 * @param isHovered - Si el sidebar está en hover (expandido temporalmente)
 */
export interface SidebarGroupProps {
  title: string;
  children?: ReactNode;
  isCollapsed?: boolean;
  isHovered?: boolean;
}

export const SidebarGroup = ({ title, children: _children, isCollapsed = false, isHovered = false }: SidebarGroupProps) => {
  const shouldShowDots = isCollapsed && !isHovered;

  return (
    <li className={`${styles.navItemHeader} ${shouldShowDots ? styles.collapsed : ''}`}>
      <div className={`${styles.groupTitle} ${shouldShowDots ? styles.hidden : ''}`}>
        {title}
      </div>
      {shouldShowDots && <div className={styles.groupIcon}>···</div>}
    </li>
  );
};

